import { ReportMenusModel } from "@app/domain/UserModel";
import { persistReportMenus, readReportMenus } from "@app/services/localStorage.service";
import { createAction, createAsyncThunk, createSlice, PrepareAction } from "@reduxjs/toolkit";

export interface ReportState {
    reportMenus: ReportMenusModel[] | null;
}

const initialState: ReportState = {
    reportMenus: readReportMenus(),
}

export const setReportMenu = createAction<PrepareAction<ReportMenusModel[]>>('report/setReportMenu', (newReportMenus) => {
    persistReportMenus(newReportMenus);

    return {
        payload: newReportMenus,
    };
})
// export const doGetReportMenus = createAsyncThunk('ReportManues', async () => {
//     try {
//       // Perform an asynchronous operation (e.g., API call)
//       const response = await getUsers();
  
//       // Return the data to be dispatched
//       return response?.data;
//     } catch (error) {
//       // Handle errors
//       throw error;
//     }
//   });
  
  export const reportMenusSlice = createSlice({
    name: 'ReportMenus',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(setReportMenu, (state, action) => {
        state.reportMenus = action.payload;
      });
    },
  });
  
  export default reportMenusSlice.reducer;